<template>
  <v-container
    fluid
    class="container pa-0"
    style="font-family: 'Montserrat', sans-serif"
  >
    <v-row no-gutters class="flex-column min-vh">
      <v-col cols="12">
        <PrivacyPortalHeader />
      </v-col>
      <v-col cols="12">
        <ReportIncidentForm />
      </v-col>
      <v-col cols="12" class="mt-auto">
        <PrivacyPortalFooter />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PrivacyPortalHeader from "@/components/PrivacyPortal/Header.vue";
import PrivacyPortalFooter from "@/components/PrivacyPortal/Footer.vue";
import ReportIncidentForm from "@/components/PrivacyPortal/ReportIncidentForm.vue";

export default {
  name: "ReportIncidentFormExternal",
  components: { PrivacyPortalHeader, PrivacyPortalFooter, ReportIncidentForm },
};
</script>

<style scoped>
.min-vh {
  min-height: 100vh;
}
.container {
  display: flex;
  flex-direction: column;
}
</style>
